import { memo } from "react";
import { AppBar, Box, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";
import Logo from "../assets/img/logo.png";
import christmasLogo from "../assets/christmas_theme_assets/LogoChristmas.png";
import NavbarSearch from "./innerComponent/NavbarSearch";
import HandleUserLogin from "./HandleUserLogin";

const Navbar = memo(() => {
  return (
    <AppBar
      position="relative"
      sx={{
        width: "100%",
        height: { xs: 56, sm: 65, xl: 110 },
        padding: { xs: "8px 0", sm: "8px 16px", lg: "5px 0" },
        px: { sm: 2, lg: 2 },

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        boxShadow: 0,
        borderRadius: 0,
        backgroundColor: 'white.main',
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          width: "100%",
          maxWidth: "false",
          mx: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: { xs: 1, sm: 2, lg: 0 },
        }}
      >
        <Link
          to="/"
          style={{
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
          }}
          aria-label="Home"
        >
          <Box
            component="img"
            sx={{
              height: { xs: 48, sm: 'auto' },
              width: { xs: 96, sm: 120, md: 130, xl: 210 },
              objectFit: "cover",
              mixBlendMode: "multiply",
              cursor: "pointer",
              zIndex: 9999999999,
              position: 'relative',
              mr: { xs: 1, sm: 2, lg: 3 },
              // top: {
              //   md: -5,
              //   lg: -5,
              //   xl: -5,
              // }
            }}
            alt="99Gift Logo"
            src={christmasLogo}
            loading="lazy"
          />
        </Link>

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            width: {
              xs: "auto",
              sm: "100%",
              md: "60%",
              lg: "55vw",
              xl: "40vw",
            },
            minHeight: { xs: 40, sm: 45, lg: 49, xl: 70 },
            maxWidth: {
              xl: '60%'
            },
            alignItems: "center",
            border: 1,
            borderColor: "lightSecondary.main",
            backgroundColor: "white.main",
            "&:hover": {
              boxShadow: 1,
            },
            borderRadius: {
              xl: 6
            },
            mx: { xs: 1, sm: 2 },
          }}
        >
          <NavbarSearch />
        </Box>

        <HandleUserLogin />
      </Toolbar>
    </AppBar>
  );
});

export default Navbar;
